module.exports = __webpack_public_path__ + "static/media/79 - Yves Simon - Au pays des merveilles de Juliet.0e3f0825.mp3";